import React, { useState, useEffect, useRef } from "react";
import { FaPhoneAlt, FaEnvelope, FaSearch, FaBars, FaTimes } from "react-icons/fa";
import "./headernew.css";
import logoNew from "../assets/images/logo1.png";
import { Link } from "react-router-dom";
import RenderOnAnonymous from "../pages/account/RenderOnAnonymous";
import RenderOnAuthenticated from "../pages/account/RenderOnAuthenticated";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import RenderOnRole from "../pages/account/RenderOnRole";
import { Container, Row, Col, Tab, Nav, Modal, Button, Navbar, NavDropdown } from 'react-bootstrap';
import UserService from "../services/UserService";
import UserActionLogin from "../pages/account/UserActionLogin";
import { useHistory } from "react-router-dom";
import service from "../services/service";
import { useDispatch, useSelector } from 'react-redux';
import { search } from '../redux-files/Actions/courseTypeAction.js';
import HearderSearchCourseList from "./HearderSearchCourseList.js";
import Sidebar from "./common/Sidebar.js";
import Marquee from "react-fast-marquee";
import { format, render, cancel, register } from "timeago.js";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

const languages = [
    {
        code: "en",
        name: "English",
        country_code: "gb",
    },
];

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const currentLanguageCode = cookies.get("i18next") || "en";
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
    const { t } = useTranslation();
    useEffect(() => {
        document.body.dir = currentLanguage.dir || "ltr";
        document.title = t("app_title");
        // console.log("CHECKIGN    ======     ", document.title)
    }, [currentLanguage, t]);

    const history = useHistory();
    const dropdownRefs = useRef({});
    const afterLogout = () => {
        // alert("Logout")
        let userId = UserService.getUserid();
        let sessionId = UserService.getSessionId();
        ////console.log(userId, sessionId);
        ////console.log("logout here");
        service.updateUserActionDetails(userId, sessionId);
        history.push("/");
    };

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (activeDropdown && dropdownRefs.current[activeDropdown]) {
                if (!dropdownRefs.current[activeDropdown].contains(event.target)) {
                    setActiveDropdown(null);
                }
            }
        };
        console.log("inside eventlistner")
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [activeDropdown]);

    let searchValue = useSelector(state => state.inputValue);

    const toggleDropdown = (dropdownName, event) => {

        console.log("inside toggleDropdown")

        event.preventDefault();
        event.stopPropagation();
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992) {
                setMenuOpen(false);
                setActiveDropdown(null);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    const dispatch = useDispatch();
    const [marqueeData, setMarqueeData] = useState([]);
    const [announcementData, setAnnouncementData] = useState([]);
    const [msg, setmsg] = useState();
    let [getSearch, setSearch] = useState();
    const [show, setShow] = useState(false);

    const searchPage = (e) => {
        setSearch(e.target.value.toLowerCase());
    }

    useEffect(() => {
        // Dispatch the search action when searchTerm changes
        dispatch(search(getSearch));
    }, [getSearch, dispatch]);

    let currentCourseState;

    // let searchEngine = useSelector(state => state.searchEngine);
    // if (searchEngine) {
    //     currentCourseState = getCourseIdsData.slice(0, 1000);
    // }

    const [getAnnouncmentModal, setAnnouncementModal] = useState(false);
    const [announcementData1, setAnnouncementData1] = useState({
        title: "",
        body: "",
        date: "",
    });
    const AnnouncementModal = (title, body, date) => {
        setAnnouncementData1({ title: title, body: body, date: date });
        setAnnouncementModal(true);
    };

    useEffect(() => {
        service
            .MarqueeByCurrentDataToPublishUpTo()
            .then((res) => {
                setMarqueeData(res.data);
            })
            .catch((err) => setmsg(t("server_error")));
    }, []);

    useEffect(() => {
        setShow(true);
        service
            .AnnouncementByCurrentDataToPublishUpTo()
            .then((res) => {
                setAnnouncementData(res.data);
            })
            .catch((err) => setmsg(t("server_error")));
    }, []);

    const dateConverter = (dateFormat) => {
        let timeAgo = format(dateFormat, "en_US");
        return timeAgo;
    };

    return (
        <div className="header-div">
            <header className="header">
                {/* Left Section */}
                <div className="header-left">
                    <img src={logoNew} alt="University Logo" className="logo" />
                    <div className="divider"></div>
                    <div className="university-info">
                        <h3>
                            School of <br /> Open Learning
                        </h3>
                    </div>
                </div>

                {/* Right Section */}
                <div className={`header-nav header-right ${menuOpen ? "open" : ""}`}>
                    <nav className="nav">
                        <ul>
                            <Navbar expand="lg" className="bg-body-tertiary">
                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/"}>HOME</Link></li>
                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/about"}>ABOUT US</Link></li>
                                <Nav className="me-auto">
                                    <NavDropdown title={
                                        <span className="dropdown-title">
                                            COURSES <i className="fa fa-angle-down dropdown-arrow"></i>
                                        </span>
                                    }
                                        id="basic-nav-dropdown">
                                        <RenderOnAuthenticated>
                                            <RenderOnRole roles={["admin"]}>
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/CourseStructureDrive"}>{t("course_Content_Drive")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/add-course-category"}>{t("course_Category")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/CreateCourse"}>{t("create_course")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/clone-course"}>{t("clone_course")}</Link></li>
                                                <NavDropdown.Divider />
                                            </RenderOnRole>
                                            <RenderOnRole roles={["instructor"]}>
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/CourseStructureDrive"}>{t("course_Content_Drive")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/add-course-category"}>{t("course_Category")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/CreateCourse"}>{t("create_course")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/ViewCourses"}>{t("authored_Courses")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/clone-course"}>{t("clone_course")}</Link></li>
                                                <NavDropdown.Divider />
                                            </RenderOnRole>
                                            <RenderOnRole roles={["learner"]}>
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/user-grid"}>{t("my_courses")}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link nav-submenu" to={process.env.PUBLIC_URL + "/course-grid"}>{t("all_courses")}</Link></li>
                                                <NavDropdown.Divider />
                                            </RenderOnRole>
                                        </RenderOnAuthenticated>
                                        <RenderOnAnonymous>
                                            <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/course-grid"}>{t("all_courses")}</Link></li>
                                            <NavDropdown.Divider />
                                        </RenderOnAnonymous>
                                    </NavDropdown>
                                    {/* <NavDropdown
                                        title={
                                            <span className="dropdown-title">
                                                E-LIBRARY <i className="fa fa-angle-down dropdown-arrow"></i>
                                            </span>
                                        }
                                        id="basic-nav-dropdown">
                                        <RenderOnAuthenticated>
                                            <RenderOnRole roles={['instructor']}>
                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/view-library"}>{t('published_book')}</Link></li>
                                                <NavDropdown.Divider />
                                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/create-library"}>{t('create_library')}</Link></li>
                                                <NavDropdown.Divider />
                                            </RenderOnRole>
                                        </RenderOnAuthenticated>
                                        <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/library-content"}>{t("all_book")}</Link></li>
                                        <NavDropdown.Divider />
                                    </NavDropdown> */}
                                    <RenderOnAuthenticated>
                                        <NavDropdown
                                            title={
                                                <span className="dropdown-title">
                                                    DASHBOARD <i className="fa fa-angle-down dropdown-arrow"></i>
                                                </span>
                                            }
                                            id="basic-nav-dropdown">

                                            {UserService.hasRole(["instructor"]) ? (
                                                <>
                                                    <li className="nav-item">
                                                        <Link
                                                            className="nav-link"
                                                            to={
                                                                process.env.PUBLIC_URL +
                                                                "/instructor-dashboard"
                                                            }
                                                        >
                                                            {t("instructor_Dashborad")}
                                                        </Link>
                                                    </li>
                                                    <NavDropdown.Divider />
                                                    <span>
                                                        {/* <li className="nav-item">
                                                            <a className="nav-link" href={`${process.env.PUBLIC_URL}/extensions/calendar`}>{t('learner_Dashboard')}</a>
                                                        </li> */}
                                                        {/* <NavDropdown.Divider /> */}
                                                        <li className="nav-item">
                                                            <a className="nav-link" href={`${process.env.PUBLIC_URL}/dashboard`}>{t('enrollment_activity')}</a>
                                                        </li>
                                                        <NavDropdown.Divider />
                                                    </span>
                                                </>
                                            ) : UserService.hasRole(["admin"]) ? (
                                                <li className="nav-item">
                                                    <Link
                                                        className="nav-link"
                                                        to={process.env.PUBLIC_URL + "/AdminDashBoard"}
                                                    >
                                                        {t("admin_Dashborad")}
                                                    </Link>
                                                </li>
                                            ) : (
                                                <span>
                                                    {/* <li className="nav-item">
                                                        <a className="nav-link" href={`${process.env.PUBLIC_URL}/extensions/calendar`}>{t('learner_Dashboard')}</a>
                                                    </li> */}
                                                    <li className="nav-item">
                                                        <a className="nav-link" href={`${process.env.PUBLIC_URL}/dashboard`}>{t('enrollment_activity')}</a>
                                                    </li>
                                                </span>
                                            )}
                                        </NavDropdown>

                                    </RenderOnAuthenticated>
                                </Nav>

                                <li className="nav-item"><Link className="nav-link" to={process.env.PUBLIC_URL + "/contact"} > CONTACT </Link> </li>

                                <Nav>
                                    <NavDropdown
                                        title={
                                            <span className="dropdown-title">
                                                <i className="las la-bell la-2x basic-nav-dropdown"></i>
                                                {announcementData.length == 0 ? null : (
                                                    <span class="badge1 badge-danger1">
                                                        {announcementData.length}
                                                        <i className="fa fa-angle-down dropdown-arrow"></i>
                                                    </span>

                                                )}
                                            </span>
                                        }
                                        id="basic-nav-dropdown">
                                        {announcementData.map((data, i) => {
                                            return (
                                                <li
                                                    onClick={() =>
                                                        AnnouncementModal(
                                                            data.title,
                                                            data.body,
                                                            dateConverter(data.publihFrom)
                                                        )
                                                    }
                                                    className="nav-item"
                                                >
                                                    <Link className="nav-link" to="#">
                                                        {data.title}{" "}
                                                        <span
                                                            style={{ fontSize: "10px", float: "right" }}
                                                        >
                                                            ({dateConverter(data.publihFrom)})
                                                        </span>
                                                    </Link>
                                                </li>
                                            );
                                        })}
                                    </NavDropdown>
                                </Nav>

                            </Navbar>
                        </ul>
                    </nav>
                    <div className="auth-buttons">
                        {/* <button className="btn login">Login</button>
                        <button className="btn register">Register</button> */}
                        <ul className="list-unstyled list-inline bar-login">
                            <RenderOnAuthenticated>
                                <li className="list-inline-item nav-item side-box">
                                    <Sidebar />
                                </li>
                            </RenderOnAuthenticated>
                            <RenderOnAnonymous>
                                <li className="list-inline-item-header login">
                                    <Link
                                        onClick={() => {
                                            UserService.doLogin();
                                        }}
                                        to="#"
                                    >
                                        <i className="las la-user"></i>
                                        {t("log_in")}
                                    </Link>
                                </li>
                            </RenderOnAnonymous>
                            <RenderOnAuthenticated>
                                <UserActionLogin />
                                <li className="list-inline-item-header logout">
                                    <Link
                                        onClick={() => [afterLogout(), UserService.doLogout()]}
                                    >
                                        <i className="las la-sign-out-alt"></i>
                                        {t("log_out")}
                                    </Link>
                                </li>
                            </RenderOnAuthenticated>
                            <RenderOnAnonymous>
                                <li className="list-inline-item-header register">
                                    <Link to={process.env.PUBLIC_URL + "/registration"}>
                                        <i className="las la-user-edit"></i>
                                        {t("register")}
                                    </Link>
                                </li>
                            </RenderOnAnonymous>

                        </ul>


                    </div>
                </div>

                <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </div>
                <div className="contact-search-container">
                    <Col className="contact-info">
                        <span>
                            <FaPhoneAlt className="icon" /> +91 (079) 239 77100 (Ext. 2225)
                        </span>
                        <span>
                            <FaEnvelope className="icon" /> sool@nfsu.ac.in
                        </span>
                    </Col>
                    <Col className="search-bar">
                        <input type="text" onChange={searchPage} id="search" autoComplete="off" name="search" placeholder={t('search_here')} />
                        <span className="search-icon-back" > <FaSearch className="search-icon" /> </span>
                    </Col>

                </div>
            </header>
            {searchValue && (
                <div className="search-overlay">
                    <HearderSearchCourseList />
                </div>
            )}
            <Container fluid>
                <Row
                    style={{ color: "#ffffff", background: "#182B49", fontSize: "15px" }}
                >
                    <Marquee pauseOnHover="true" style={{ marginLeft: "10px" }}>
                        {marqueeData.length == 0
                            ? null
                            : marqueeData.map((data, index) => {
                                return (<>
                                    <React.Fragment key={index}>
                                        {data.body}
                                    </React.Fragment>
                                    {(marqueeData.length != 1) && (<span style={{ color: "#ffaa0d" }}>{'\u00A0'}{'\u00A0'}||{'\u00A0'}{'\u00A0'}</span>)}
                                </>
                                )
                            })}
                    </Marquee>
                </Row>
            </Container>
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={getAnnouncmentModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {announcementData1.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {ReactHtmlParser(ReactHtmlParser(announcementData1.body))}
                </Modal.Body>
                <Modal.Footer>
                    <span style={{ fontSize: "10px", position: "sticky" }}>
                        {announcementData1.date}
                    </span>
                    <Button onClick={() => setAnnouncementModal(false)}>
                        {t("close")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>




    );
}
